export const environment = {
  production: true,
  buildId: '3282449624021091',
  configFile: 'config.json',
};
